import { tokenPocket, tokenPocketDark } from "../../../utils";

export default {
  product: {
    title: '產品',
    label_1: 'KeyPal',
    label_2: '助記詞密盒',
    label_3: '皮革保護套',
    label_4: '所有產品',
    label_5: 'KeyPal Card',
  },
  upgrade: {
    label_1: '升级',
  },
  // learn标题下面的描述我不知道是什么文案
  learn: {
    label_1: '安全',
  },
  others: {
    label_1: '關於',
    label_2: '隱私協議',
    label_3: '使用條款',
  },
  support: {
    title: '支援',
    label_1: '幫助中心',
    label_2: '購買問答',
    label_3: '社區中心',
  },
  cryptoAssets: {
    title: '加密資產',
    label_1: '比特幣錢包',
    label_2: '以太坊錢包',
    label_3: 'Solana 錢包',
    label_4: 'Tron 錢包',
    label_5: '穩定幣錢包',
  }, 
  getStarted: {
    title: '開始使用',
    label_1: '如何確保你的錢包安全？',
    label_2: '如何使用 KeyPal 2？',
    label_3: '如何使用 KeyPal Card？',
    label_4: '如何使用 KeyPal Plus？',
    label_5: '如何使用 Secret Box？',
  }, 
  download: {
    title: '下載',
    label_1: '行動錢包',
    label_2: '擴充功能錢包',
    label_3: '升级',
  }, 
  legal: {
    title: '政策',
    label_1: '隱私政策',
    label_2: '使用條款',
  }, 

  designed: `由 ${tokenPocket} 設計 ❤️`,
  designedDark: `由 ${tokenPocketDark} 設計 ❤️`,
};
